// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrumb_breadcrumb__LiP64","custom":"BreadCrumb_custom__ORZ2m"};